export enum ELoadStatus {
  failure = 'failure',
  initial = 'initial',
  initialLoad = 'initialLoad',
  loading = 'loading',
  success = 'success',
}
